import {
  qryBrowserLogList,
  qryPortals,
  qryUsers,
} from '@pages/BrowserAnalysisMgr/services/browserLog';

const handleParams = params => {
  if (!params || JSON.stringify(params) === '{}') return params;
  const newParam = {};
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== '') newParam[key] = value;
  });
  return newParam;
};

export default {
  namespace: 'browserAnalysisMgr',

  state: {
    logData: {
      list: [],
      pagination: {},
    },
    filterLog: {},
    userData: {
      list: [],
      pagination: {},
    },
    filterUser: {},
    portalList: [],
  },

  effects: {
    *qryBrowserLogList({ payload }, { call, put }) {
      const { success, data } = yield call(qryBrowserLogList, handleParams(payload));
      if (success) {
        const { list, pageSize, total, pageNum } = data;
        list.map(v => {
          Object.assign(v, { key: `log_${v.logId}` });
          return v;
        });
        yield put({
          type: 'save',
          payload: {
            logData: {
              list,
              pagination: {
                current: pageNum,
                pageSize,
                total,
              },
            },
            filterLog: {
              ...payload,
            },
          },
        });
      }
    },
    *qryPortals(_, { call, put }) {
      const { success, data } = yield call(qryPortals);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            portalList: data,
          },
        });
      }
    },
    *qryUsers({ payload }, { call, put }) {
      const { success, data } = yield call(qryUsers, payload);
      if (success) {
        const { list, pageSize, total, pageNum } = data;
        list.map(v => {
          Object.assign(v, { key: `user_${v.userId}` });
          return v;
        });
        yield put({
          type: 'save',
          payload: {
            userData: {
              list,
              pagination: {
                current: pageNum,
                pageSize,
                total,
              },
            },
            filterUser: {
              ...payload,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
